<app-floorplan-item-details
  [extent]="extent()"
  [isExtendable]="true"
  [floorplanItem]="display()"
  [imageUrl]="imageUrl"
  (toggleExtendedButtonClicked)="toggleExtendedButtonClicked.emit()"
>
  <div data-main>
    <app-floorplan-item-attachments-button
      [productItems]="productItems"
      [monitoringCategory]="MonitoringCategory.DISPLAYS"
      [monitoringItems]="monitoringItems"
      [monitoringTitle]="monitoringTitle"
    ></app-floorplan-item-attachments-button>
    <app-floorplan-item-group [floorplanItem]="display()"></app-floorplan-item-group>
  </div>
  @if (extent() !== SidesheetExtent.None) {
    <div data-extended>
      <app-floorplan-custom-part-numbers [floorplanItem]="display()"></app-floorplan-custom-part-numbers>
    </div>
  }
</app-floorplan-item-details>
